import _objectWithoutProperties from "/vercel/path0/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties";
import _defineProperty from "/vercel/path0/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty";
var _excluded = ["sticker"];
var __jsx = React.createElement;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import * as React from 'react';
import styled from 'styled-components';
import { NextSeo } from 'next-seo';
import * as ds from '@bob/design-system';
import { styles as S } from '@bob/design-system';
import { hash } from '@bob/utils';
import * as url from '@bob/url';
import { SITE_URL, SITE_NAME } from '../../../../constants';
import { Head } from './Head';
import { Rationale } from '../../../../components/Rationale';
import { Description } from './Description';
import { AssociatedContents } from './AssociatedContents';
import { MomentStickers } from '../../../../components/MomentStickers';
import { TagList } from '../../../../components/TagList';
import * as DetailLayout from '../../../../components/layout/DetailLayout';
import { StarProducts } from './StarProducts';
export function BrandDetail(_ref) {
  var _brand$seo$alt, _brand$seo$height, _brand$seo$width;

  var brand = _ref.brand;
  var pageUrl = url.brand({
    slug: brand.slug,
    name: brand.name
  });
  return __jsx(React.Fragment, null, __jsx(NextSeo, {
    title: "".concat(brand.name, " sur ").concat(SITE_NAME),
    description: brand.descriptionShort,
    canonical: SITE_URL + pageUrl.path,
    openGraph: {
      title: "".concat(brand.name, " sur ").concat(SITE_NAME),
      description: brand.descriptionShort,
      url: SITE_URL + pageUrl.path,
      // FIXME: when coverImage is set in contentful for all brands, remove null guard
      images: brand.seo ? [{
        alt: (_brand$seo$alt = brand.seo.alt) !== null && _brand$seo$alt !== void 0 ? _brand$seo$alt : undefined,
        height: (_brand$seo$height = brand.seo.height) !== null && _brand$seo$height !== void 0 ? _brand$seo$height : undefined,
        url: brand.seo.src,
        width: (_brand$seo$width = brand.seo.width) !== null && _brand$seo$width !== void 0 ? _brand$seo$width : undefined
      }] : undefined
    },
    robotsProps: {
      maxImagePreview: 'large'
    }
  }), __jsx(DetailLayout.Container, null, __jsx(ds.BreadCrumbs, {
    crumbs: pageUrl.crumbs
  }), __jsx(GalleryColumn, null, __jsx(ds.Gallery, {
    initialFocused: 0,
    list: brand.images.map(function (image) {
      var _image$alt, _image$width, _image$height;

      return _objectSpread(_objectSpread({}, image), {}, {
        alt: (_image$alt = image.alt) !== null && _image$alt !== void 0 ? _image$alt : undefined,
        width: (_image$width = image.width) !== null && _image$width !== void 0 ? _image$width : undefined,
        height: (_image$height = image.height) !== null && _image$height !== void 0 ? _image$height : undefined
      });
    })
  }), __jsx(StickerWrapper, null, __jsx(BrandSticker, {
    sticker: sticker(brand)
  }))), __jsx(DetailLayout.Main, null, __jsx(Head, {
    brand: brand
  }), __jsx(Rationale, {
    environmentalPillars: brand.pillars.environmental,
    rationale: brand.rationale,
    socialPillars: brand.pillars.social,
    title: "Engagements de la marque"
  }), __jsx(Description, {
    brand: brand
  }))), __jsx(StarProducts, {
    brand: brand
  }), __jsx(ds.Ribbon, {
    cycles: 4,
    timing: 10,
    title: "bien ou bien, tous les jours avec vous"
  }), __jsx(SmallContainer, null, __jsx(MomentStickers, {
    moments: brand.moments.map(function (moment) {
      return {
        icon: moment.extra.icon,
        slug: moment.slug
      };
    })
  }), brand.tags.length > 0 && __jsx(React.Fragment, null, __jsx(S.heading.TitleCardArticle, {
    as: "h3"
  }, "Tags associ\xE9s"), __jsx(TagList, {
    context: "brand",
    tagList: brand.tags
  }))), __jsx(AssociatedContents, {
    brand: brand
  }));
}

function sticker(brand) {
  if (brand.sticker !== null) {
    return brand.sticker;
  }

  var brandHasher = hash.createHash();
  brandHasher.update(brand.slug);
  var brandHash = brandHasher.digest('number');
  var stickerNames = Object.keys(ds.stickers.criteria).filter(function (name) {
    return brand.isDistributed || name !== 'Checked' && name !== 'Guaranteed';
  });
  return stickerNames[brandHash % stickerNames.length];
}

function BrandSticker(_ref2) {
  var sticker = _ref2.sticker,
      rest = _objectWithoutProperties(_ref2, _excluded);

  var Sticker = ds.stickers.criteria[sticker];
  return __jsx(Sticker, rest);
}

var SmallContainer = styled(ds.Container).withConfig({
  displayName: "BrandDetail__SmallContainer",
  componentId: "sc-1ud68qv-0"
})(["text-align:center;display:flex;flex-direction:column;align-items:center;", "{margin:20px 0;}"], S.heading.TitleCardArticle);
var StickerWrapper = styled.div.withConfig({
  displayName: "BrandDetail__StickerWrapper",
  componentId: "sc-1ud68qv-1"
})(["width:25%;height:0;padding-bottom:25%;position:relative;", "{min-width:100px;min-height:100px;max-width:166px;max-height:166px;position:absolute;width:100%;height:100%;}"], ds.stickers.Sticker);
var GalleryColumn = styled(DetailLayout.GalleryColumn).withConfig({
  displayName: "BrandDetail__GalleryColumn",
  componentId: "sc-1ud68qv-2"
})(["", "{position:absolute;top:160px;right:20px;@media screen and (", "){top:150px;right:0;}@media screen and (", "){top:150px;right:-20px;}@media screen and (", "){right:-60px;}@media screen and (", "){right:-100px;}}"], StickerWrapper, ds.breakpoint.MOBILE_M, ds.breakpoint.MOBILE_L, ds.breakpoint.LAPTOP, ds.breakpoint.LAPTOP_L);